/* eslint-disable */
import { produce } from "immer";
import {
  LEARN_SUPPORT_FETCH_FAILURE,
  LEARN_SUPPORT_FETCH_SUCCESS,
  LEARN_SUPPORT_FETCH_START,
} from "../actions/types";

const learnSupport = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case LEARN_SUPPORT_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case LEARN_SUPPORT_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case LEARN_SUPPORT_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default learnSupport;
